const RegistryScope = Object.freeze({
  custom: 'CUSTOM',
  default: 'DEFAULT',
});

export default RegistryScope;
